export const POI_FIELDS = {
    CUSTOM_SEARCHES: 'customSearches',
    ADDITIONAL_ATTRIBUTES: 'additionalAttributes',
    AIRLINE_CODE: 'airlineCode',
    AIRPORT: 'airport',
    ATTRIBUTES: 'attributes',
    CATEGORY: 'category',
    CATEGORY_SEARCH: 'categorySearch',
    DESCRIPTION: 'description',
    DISPLAY_PROPERTIES: 'displayProperties',
    DISPLAY_TAGS: 'displayTags',
    FLOOR: 'floor',
    GATE: 'gate',
    HOURS: 'hours',
    ICON: 'icon',
    ID: 'id',
    IMAGES: 'images',
    LOGO: 'logo',
    NAME: 'name',
    NO_DIRECTIONS: 'noDirections',
    PHONE: 'phone',
    RAW_HOURS: 'rawHours',
    ROTATION_PROPERTIES: 'rotationProperties',
    SECURITY: 'security',
    TAGS: 'tags',
    TERMINAL: 'terminal',
    URL: 'url',
    URL_DISPLAY: 'urlDisplay',
    VENUE_ID: 'venueId',
    SHOWING: 'showing',
};

export const TABS = [
    {
        id: 'display',
        label: 'DISPLAY',
        fields: [POI_FIELDS.CATEGORY, POI_FIELDS.ICON],
    },
    {
        id: 'info',
        label: 'INFO',
        fields: [
            POI_FIELDS.TERMINAL,
            POI_FIELDS.FLOOR,
            POI_FIELDS.GATE,
            POI_FIELDS.DESCRIPTION,
            POI_FIELDS.URL,
            POI_FIELDS.PHONE,
            POI_FIELDS.RAW_HOURS,
            POI_FIELDS.ADDITIONAL_ATTRIBUTES,
            POI_FIELDS.SECURITY,
        ],
    },
    {
        id: 'images',
        label: 'IMAGES',
        fields: [POI_FIELDS.IMAGES, POI_FIELDS.LOGO],
    },
    {
        id: 'tags',
        label: 'TAGS',
        fields: [POI_FIELDS.DISPLAY_TAGS, POI_FIELDS.TAGS],
    },
    {
        id: 'internal',
        label: 'INTERNAL',
        fields: [
            POI_FIELDS.AIRLINE_CODE,
            POI_FIELDS.ATTRIBUTES,
            POI_FIELDS.CATEGORY_SEARCH,
            POI_FIELDS.ROTATION_PROPERTIES,
            POI_FIELDS.DISPLAY_PROPERTIES,
            POI_FIELDS.URL_DISPLAY,
            POI_FIELDS.CUSTOM_SEARCHES,
        ],
    },
    {
        id: 'json',
        label: 'JSON',
        fields: [],
    },
];
